<div class="quote-user-info">

  <div>
    <span class="text-small-regular">Cliente</span>
    <p class="text-body-medium">{{(user$ | async)?.aliasCustumer}}</p>
  </div>

  <div *ngIf="address">
    <span class="text-small-regular">Dirección</span>
    <p class="text-body-medium">{{address}}</p>
  </div>

  <div>
    <span class="text-small-regular">Atención</span>
    <p class="text-body-medium">{{(user$ | async)?.firstNameUser}} {{(user$ | async)?.lastNameUser}}</p>
    <p class="text-body-medium">{{(user$ | async)?.position}} <span *ngIf="(user$ | async)?.position || (user$ | async)?.department">/</span> {{(user$ | async)?.department}}</p>
  </div>

  <div class="quote-user-info__contact">
    <div>
      <span class="text-small-regular">Teléfono</span>
      <p class="text-body-medium">{{(user$ | async)?.phoneNumberUser}}</p>
    </div>
    <div>
      <span class="text-small-regular">Email</span>
      <p class="text-body-medium">{{(user$ | async)?.emailUser}}</p>
    </div>
  </div>
</div>
